import { DraftAccount } from "@/entities/DataAssociation/Draft.model";
import { StatementType } from "@/entities/DataAssociation/File.model";

export type SelectedAccountRow = {
    account: DraftAccount | null;
    rowHeader: string;
    rowIndex: string;
};

export enum LabelListStatementType {
    BALANCE_SHEET = "balance sheet",
    INCOME_STATEMENT = "income statement",
}

export enum AccountPanelView {
    NEW_ACCOUNT = "newAccount",
    ACCOUNT_LIST = "accountList",
}

export enum AccountAppearanceState {
    DISABLED = "disabled",
    TENTATIVE = "tentative", // used for rows with unconfirmed hints etc.
    DEFAULT = "default",
}

export enum FileStatusOptions {
    UNLABELED = "unlabeled",
    LABELED = "labeled",
    CLEANED = "cleaned",
    ALL = "all",
}

export type FileListStatementType = StatementType | "all";

export const STATEMENT_TYPE_LABELS: Record<FileListStatementType, string> = {
    [StatementType.BALANCE_SHEET]: "Balance sheet",
    [StatementType.INCOME_STATEMENT]: "Income statement",
    [StatementType.MIXED]: "Mixed",
    all: "All statements",
};
